import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import styled, { css } from 'styled-components';
import { green, screenSmMin, screenXsMax } from '@spotify-internal/encore-foundation';
import { colors, getColorOrDefault } from "../../styles/theme";
import { fontWeightBold, fontWeightBook, ie11Edge, typeStyleBody2, typeStyleBody3 } from "../../styles";

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.app === 'dark';
};

export default styled(function (_ref) {
  var render = _ref.render,
      props = _objectWithoutProperties(_ref, ["render"]);

  return render(props);
}).withConfig({
  displayName: "Link",
  componentId: "sc-1juxjd0-0"
})(["display:block;text-decoration:none;color:inherit;&:hover,&:focus{color:", ";text-decoration:", ";}@media (max-width:", "){", ";font-weight:", ";}@media (min-width:", "){", ";font-weight:", ";}", ";"], function (props) {
  return isDarkTheme(props) ? 'inherit' : getColorOrDefault(props.theme, colors.primaryColor, green);
}, function (props) {
  return isDarkTheme(props) ? 'underline' : 'none';
}, screenXsMax, typeStyleBody2(), fontWeightBold, screenSmMin, typeStyleBody3(), fontWeightBold, ie11Edge(css(["font-weight:", ";"], fontWeightBook)));